const init = () => {

  const points = document.querySelectorAll(`.io-point`)

  if (points.length) {
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.body.dataset.section = entry.target.dataset.section
          document.querySelector(`.section[data-section="${entry.target.dataset.section}"]`).classList.add(`is-active`)
          document.querySelector(`.section[data-section="${entry.target.dataset.section}"]`).classList.add(`is-viewed`)
        } else {
          document.querySelector(`.section[data-section="${entry.target.dataset.section}"]`).classList.remove(`is-active`)
        }
      })
    })

    for (const item of points) {
      observer.observe(item)
    }
  
  } else {
    document.body.dataset.section = `default`
  }

}

export default {
  init
}
